import { render } from "./AgentMetaData.vue?vue&type=template&id=f54beeda"
import script from "./AgentMetaData.vue?vue&type=script&lang=js"
export * from "./AgentMetaData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__